<span [matTooltip]="(active ? 'GridTable.Filter.FilterActive' : 'GridTable.Filter.FilterInactive') | translate">
  <button mat-icon-button
          (click)="onRemove()"
          color="primary"
          [disabled]="!active">
    <mat-icon class="me-2">
      filter_alt
    </mat-icon>
  </button>
</span>
